import React, { ReactElement } from 'react';

import { NotFoundRedirect } from '../../shared/not-found-redirect/NotFoundRedirect';

import { ActiveExperience } from './ActiveExperience/ActiveExperience.component';
import { ClosedExperience } from './ClosedExperience/ClosedExperience.component';

export function Experience (): ReactElement | null {
    if (window.ozClosedExperienceApp) {
        return <ClosedExperience />;
    }

    if (window.ozActiveExperienceApp) {
        return <ActiveExperience />;
    }

    return (
        <NotFoundRedirect />
    );
}
